import React from "react";
import Container from "./Container";

/**
 * @param {object} props
 * @param {Array} props.containers
 * @returns {React.ReactElement}
 */
const RecurringSummaryPageContainers = ({ containers }) => {
    const containerProps = {
        page: "recurring-summary",
    };

    return containers.map((container = {}) => {
        const { options = {} } = container;
        const { isConfirmationFieldsContainer = false } = options;

        // Recurring Summary should not have confirmation fields
        if (isConfirmationFieldsContainer) {
            return null;
        }

        return (
            <Container
                key={container.id}
                container={container}
                {...containerProps}
            />
        );
    });
};

export default RecurringSummaryPageContainers;
